export default __webpack_public_path__ + "static/media/EESymbolsImg2.75be12b0.jpg";